<template>
    <div class="key_exchange">
		<el-dialog @close="showUserInfoPop" center :visible.sync="dialogVisible" top="10vh" width="780px" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">免费会员</div>
				<div class="close_btn" @click="dialogVisible = false"><img class="close_icon" src="../views/img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content">
                <div class="free_item">
                    <div class="item_top">
                        <div class="top_left">
                            <img class="item_icon" src="../views/img/img_icon_05.png" alt="">
                            <div class="top_left_main">
                                <div class="item_name">小红书种草<span class="focus_tag">关注</span><img class="code_img" src="./img/img_icon_10.png" alt=""></div>
                                <div class="item_desc">兑换5天-15天会员</div>
                            </div>
                        </div>
                        <div class="top_right">
                            <el-button size="medium" type="primary">参与</el-button>
                            <el-button size="medium" type="info">奖励记录</el-button>
                        </div>
                    </div>
                    <div class="item_content">
                        <div class="content_text">在小红书关注“懒人办公”官号，发布Ai写作的种草笔记或视频并@懒人办公，要求三张配图和大于50字，发布就可获得5天会员，每1点赞增加1天会员，最多加15天。</div>
                    </div>
                </div>
                <div class="free_item">
                    <div class="item_top">
                        <div class="top_left">
                            <img class="item_icon" src="./img/img_icon_07.png" alt="">
                            <div class="top_left_main">
                                <div class="item_name">抖音短视频<span class="focus_tag">关注</span><img class="code_img" src="./img/img_icon_10.png" alt=""></div>
                                <div class="item_desc">兑换3天-10天会员</div>
                            </div>
                        </div>
                        <div class="top_right">
                            <el-button size="medium" type="primary">参与</el-button>
                            <el-button size="medium" type="info">奖励记录</el-button>
                        </div>
                    </div>
                    <div class="item_content">
                        <div class="content_text">在抖音关注“懒人办公”官号，发布Ai写作的种草笔记或视频并@懒人办公，要求三张配图和大于50字，发布后第二天就可获得3天会员，每10点赞增加1天会员最多加10天</div>
                    </div>
                </div>
                <div class="free_item">
                    <div class="item_top">
                        <div class="top_left">
                            <img class="item_icon" src="./img/img_icon_08.png" alt="">
                            <div class="top_left_main">
                                <div class="item_name">特别贡献者</div>
                                <div class="item_desc">送1月 - N月会员免费时长不等，上不封顶</div>
                            </div>
                        </div>
                        <div class="top_right">
                            <el-button size="medium" type="primary">参与</el-button>
                            <el-button size="medium" type="info">奖励记录</el-button>
                        </div>
                    </div>
                    <div class="item_content">
                        <div class="content_line">在抖音或者小红书发布的种草笔记或视频>100个赞送月费会员，大于200个赞送2个月会员，依次类推</div>
                        <div class="content_line">同上，种草笔记或视频>500个送年费会员，1000个赞送2年年费会员，上不封顶</div>
                    </div>
                </div>
                <div class="free_item">
                    <div class="item_top">
                        <div class="top_left">
                            <img class="item_icon" src="./img/img_icon_09.png" alt="">
                            <div class="top_left_main">
                                <div class="item_name">邀请好友</div>
                                <div class="item_desc">兑换10000字数包/每人，上不封顶</div>
                            </div>
                        </div>
                        <div class="top_right">
                            <el-button size="medium" type="primary">参与</el-button>
                            <el-button size="medium" type="info">奖励记录</el-button>
                        </div>
                    </div>
                    <div class="item_content">
                        <div class="link_line"><el-input v-model="self_link"></el-input><el-button type="info" style="width:110px;margin-left:12px;">复制链接</el-button></div>
                        <div class="content_text">* 成功邀请一个用户可获得10000字数包，次日到账，享钻石会员权限!(被邀请用户写作文字大于100文字算成功)</div>
                    </div>
                </div>
            </div>
		</el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                dialogVisible:false,
                self_link:"https://www.zhanjuzhe.com/doc/7Oyrs 5gUX4S",
                tableData:[]
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.dialogVisible = true;
            },
            showUserInfoPop(){
                this.$emit("showUserInfoPop")
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .dialog_content{
        padding: 0 30px 5px;
        .free_item{
            padding: 26px 0 16px;
            &:not(:last-child){
                border-bottom: 1px solid #eee;
            }
            .item_top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                .top_left{
                    display: flex;
                    align-items: center;
                    .item_icon{
                        width: 36px;
                        height: 36px;
                        margin-right: 12px;
                    }
                    .top_left_main{
                        white-space: nowrap;
                        .item_name{
                            line-height: 16px;
                            margin-bottom: 6px;
                            .focus_tag{
                                margin: 0 7px;
                                font-size: 12px;
                                color: #07c160;
                                background-color: #b7fdd8;
                                border-radius: 2px;
                                padding: 0 7px;
                            }
                            .code_img{
                                width: 14px;
                                vertical-align: middle;
                            }
                        }
                        .item_desc{
                            font-size: 12px;
                            line-height: 14px;
                            color: #dec044;
                        }
                    }
                }
            }
            .item_content{
                .content_text{
                    font-size: 13px;
                    color: #999;
                    line-height: 25px;
                    margin-top: -6px;
                }
                .content_line{
                    background-color: #eee;
                    padding: 0 16px;
                    line-height: 44px;
                    color: #999;
                    font-size: 13px;
                    margin-bottom: 20px;
                    &:last-child{
                        margin-bottom: 10px;
                    }
                }
                .link_line{
                    display: flex;
                    margin-bottom: 14px;
                    .el-input{
                        flex-grow: 1;
                    }
                }
            }
        }
    }
</style>